import React, { useEffect, useRef, useState } from 'react';
import './OneTimeCharge.scss';
import { Checkbox, CircularProgress } from '@material-ui/core';
import Button from '../../components/Button/Button';
import AutoComplete from '../../components/AutoComplete/AutoComplete';
import SelectDropDown from '../../components/SelectDropDown/SelectDropDown';
import TextField from '../../components/Textfield/TextField';
import _ from 'lodash';
import { geocodeByAddress } from 'react-places-autocomplete';
import { usaState } from '../../global/USAStateList';
import { useDispatch, useSelector } from 'react-redux';
import {  CreateCustomer, GetCustomer, ShippmentOrder, StateCityByZipcode, UpdateCustomerSource } from '../../store/Checkout/actions';
import { customerGroup } from '../../store/PostActivation/actions';
// import { pushTrackingEventsToGAAndFBNew } from '../../global/commonFunctions/GaAndFb';
import TagManager from 'react-gtm-module';
import { maxLength } from '../../config';

type initialProps = {
    history: any;
    setIsChangeAddress?: any;
    deviceDetails: any;
    setIsLineAdded: any;
    setIsShipmentFailed: any;
    setIsAddLineCharges: any;
    setIsAddLineSummary: any;
};

const OneTimeCharge = (props: initialProps) => {
    const {
        setIsChangeAddress,
        deviceDetails,
        setIsLineAdded,
        setIsShipmentFailed,
        setIsAddLineCharges,
        setIsAddLineSummary,
    } = props;
    const [customerDetails, setCustomerDetails] = useState<any>(null);
    const [isBillingAddress, setIsBillingAddress] = useState(true);
    const [changeShipAddress, setChangeShipAddress] = useState(false);
    const [shippingAddress, setShippingAddress] = useState<any>({});
    const [billingAddress, setBillingAddress] = useState<any>({});
    const [shippingRates, setShippingRates] = useState<any>(null);
    const [loader, setLoader] = useState(false);
    const [userCreated, setUserCreated] = useState<boolean>(false);
    const [formData, setFormData] = useState<any>({
        name: '',
        address1: '',
        address2: '',
        city: '',
        state: '',
        zip: '',
        stateCode: '',
        stateCodeShipping: '',
        shipPlan: '',
        country: 'USA'
    });
    const [formDataValidation, setFormDataValidation] = useState(false);
    const [simCost, setSimCost] = useState<any>(null);
    const [isStandardAcc, setIsStandardAcc] = useState<boolean>(false);

    const dispatch = useDispatch();
    const { checkout, activation } = useSelector((state: any) => state);

    useEffect(() => {
        let customerDetails: any = localStorage.getItem('customerDetail');
        customerDetails = JSON.parse(customerDetails);
        if(customerDetails?.category === 'STANDARD') {
            setIsStandardAcc(true)
        }
        setCustomerDetails(customerDetails);
        let shippingAdd: any =
            customerDetails &&
            customerDetails.addresses &&
            customerDetails.addresses.find((el: any) => el.type === 'shipping');
        let billingAdd: any =
            customerDetails &&
            customerDetails.addresses &&
            customerDetails.addresses.find((el: any) => el.type === 'billing');
        formData['name'] = shippingAdd.name;
        formData['type'] = shippingAdd.type;
        setFormData(formData)
        setShippingAddress({ ...shippingAdd });
        setBillingAddress({ ...billingAdd });
    }, []);

    useEffect(() => {
        if (activation?.getAppData?.data && activation?.getAppData.status === 'SUCCESS') {
            const data = activation?.getAppData?.data.perSimCost.USA;
            let simCost = ((100 - data.discountPctg) * data.cost) / 100;
            setSimCost(simCost);

            const shippingRates = activation?.getAppData?.data?.shippingRates[0];
            setShippingRates(shippingRates);
        }
    },[activation.getAppData])

    const initialRender1 = useRef(true);
    useEffect(() => {
        if (initialRender1.current === true) {
            initialRender1.current = false;
        } else {
            const createCustomer = checkout.createCustomer;
            const errorCreateCustomer = checkout.errorCreateCustomer;
            if (createCustomer && createCustomer.status === 'SUCCESS' && createCustomer.data) {
                localStorage.setItem('secondaryCustomerDetail', JSON.stringify(createCustomer.data));
                executeShipmentOrder(createCustomer.data);
                setUserCreated(true);
                if(!isStandardAcc) {
                    setLoader(false)
                    setIsLineAdded(true)
                }
            }
            if (errorCreateCustomer && errorCreateCustomer.status === 'FAILURE') {
                console.log('CREATE CUSTOMER FAILED');
                setLoader(false);
            }
        }
    }, [checkout.createCustomer, checkout.errorCreateCustomer]);

    const initialRender2 = useRef(true);
    useEffect(() => {
        if (initialRender2.current === true) {
            initialRender2.current = false;
        } else {
            const shippmentOrder = checkout.shippmentOrder;
            const errorShippmentOrder = checkout.errorShippmentOrder;
            if (shippmentOrder && shippmentOrder.status === 'SUCCESS' && shippmentOrder.data) {
                setIsLineAdded(true);
                setLoader(false);
                dispatch(customerGroup({ groupId: customerDetails && customerDetails.groupId }));
                dispatch(GetCustomer({ username: encodeURIComponent(customerDetails && customerDetails.emailId) }));
            }
            if (errorShippmentOrder && errorShippmentOrder.status === 'FAILURE') {
                setLoader(false);
                setIsLineAdded(false);
                setIsShipmentFailed(true);
                setIsAddLineCharges(false);
                setIsAddLineSummary(false);
            }
        }
    }, [checkout.shippmentOrder, checkout.errorShippmentOrder]);

    const initialRender3 = useRef(true);
    useEffect(() => {
        if (initialRender3.current === true) {
            initialRender3.current = false;
        } else {
            const updateCustomer = checkout.updateCustomerSource;
            if (updateCustomer && updateCustomer.status === 'SUCCESS' && updateCustomer.data) {
                setChangeShipAddress(false);
                setIsChangeAddress(false);
                setLoader(false);
            }
        }
    }, [checkout.updateCustomerSource]);

    const addressUpdateFunction = (formData: any) => {
        let address: any = [
            {
                name: `${formData && formData.firstName} ${formData && formData.lastName}`,
                address1: formData && formData.address1,
                address2: formData && formData.address2,
                city: formData && formData.city,
                country: 'USA',
                phone: formData && formData.billingNumber,
                state: formData && formData.stateCode,
                type: 'billing',
                zip: formData && formData.zip,
            },
            {
                address1: formData && formData.sameAddress ? formData.address1 : formData.streetShipping,
                address2: formData && formData.sameAddress ? formData.address2 : formData.aptShipping,
                city: formData && formData.sameAddress ? formData.city : formData && formData.cityShipping,
                country: 'USA',
                name: `${formData && formData.firstName} ${formData && formData.lastName}`,
                phone: formData && formData.billingNumber,
                state: formData && formData.sameAddress ? formData.stateCode : formData && formData.stateCodeShipping,
                type: 'shipping',
                zip: formData && formData.sameAddress ? formData.zip : formData && formData.zipCodeShipping,
            },
        ];
        localStorage.setItem('addresses', address);
    };

    const onChangeHandler = async (e: any, name: string) => {
        name !== 'address1' && name !== 'sameAddress' && name !== 'streetShipping'
            ? setFormData(_.set({ ...formData }, name, e.target.value))
            : setFormData(_.set({ ...formData }, name, e));

        if (name === 'zip') {
            let zip = e.target.value;
            zip.length >= 5 && /^\d+$/.test(zip) && dispatch(StateCityByZipcode({ zipcode: zip, countryCode: 'USA' }));
        }
        if (name === 'state') {
            let code: string = findCodeByState(e.target.value);
            let label: string = findLabelByState(e.target.value);
            name === 'state' ? (formData['stateCode'] = code) : (formData['stateCodeShipping'] = code);
            formData['state'] = label;
            setFormData(formData);
            addressUpdateFunction(formData);
        }
    };

    const handleSelect = (address: any, type: string) => {
        geocodeByAddress(address)
            .then(async (results: any) => {
                let city: string = '',
                    state: string = '',
                    zip: string = '',
                    country: string = '',
                    route: string = '',
                    streetNumber: string = '';
                results &&
                    results[0] &&
                    results[0].address_components &&
                    results[0].address_components.map((el: any) => {
                        state = el.types.includes('administrative_area_level_1') ? el.long_name : state;
                        zip = el.types.includes('postal_code') ? el.short_name : zip;
                        city = el.types.includes('locality')
                            ? el.long_name
                            : el.types.includes('sublocality')
                            ? el.long_name
                            : el.types.includes('neighborhood')
                            ? el.long_name
                            : city;
                        streetNumber = el.types.includes('street_number') ? el.short_name : streetNumber;
                        route = el.types.includes('route') ? el.long_name : route;
                        country = el.types.includes('country') ? el.short_name : country;
                        return null;
                    });
                let code = findCodeByState(state);

                if (type === 'billing' && country === 'US') {
                    formData['address1'] = `${streetNumber} ${route}`;
                    formData['city'] = city;
                    formData['state'] = state;
                    formData['zip'] = zip;
                    formData['stateCode'] = code;
                    setFormData(_.set({ ...formData }, formData));
                }
            })
            .catch(error => console.error('error', error));
    };

    const findCodeByState = (state: string) => {
        let code = usaState.find((el: any) => el.label.toLowerCase() === state.toLowerCase());
        return code && code.value;
    };

    const findLabelByState = (state: string) => {
        let code = usaState.find((el: any) => el.label.toLowerCase() === state.toLowerCase());
        return code && code.label;
    };

    const validateData = (formData: any) => {
        if (formData.firstName === '' || formData.lastName === '') {
            return false;
        }
        if (
            formData.address1 === '' ||
            formData.city === '' ||
            formData.state === '' ||
            formData.stateCode === '' ||
            formData.zip === '' || 
            formData.city.length < 2
        ) {
            return false;
        }
        if (formData.zip !== '' && formData.zip.length < 5) {
            return false;
        }
        return true;
    };
    const updateCustomerHandler = (val: any) => {
        let shippingAdd: any =
            customerDetails &&
            customerDetails.addresses

        shippingAdd.map((el:any) => {
            if(el.type === "shipping") {
                el.address1 = val?.address1;
                el.city = val?.city;
                el.state = val?.state;
                el.phone = "";
                el.zip = val?.zip;
                el.address2 = val?.address2 ? val.address2 : '';
            }
        })
        setLoader(true);
        dispatch(
            UpdateCustomerSource({
                customerId: customerDetails?.id,
                data: {
                    addresses: shippingAdd
                },
            }),
        );
    };

    const saveHandler = () => {
        setFormDataValidation(true);
        if (validateData(formData)) {
            setShippingAddress(_.set({ ...formData }));
            updateCustomerHandler(formData)
        }
        // GAAndFBEventsHandler("Change_Address")
        TagManager.dataLayer({
            dataLayer: {
              event: "Change_Address",
            },
          });
    };

    // const GAAndFBEventsHandler = (buttonVal: string,) => {
    //     pushTrackingEventsToGAAndFBNew("event", buttonVal, {
    //       screenName: "home",
    //       buttonValue: buttonVal, 
    //     });
    //   };

    const handleCreateCustomer = () => {
        // GAAndFBEventsHandler("Confirm_Order")
        const address:any = [shippingAddress].flat() 
        TagManager.dataLayer({
            dataLayer: {
              event: "Confirm_Order",
            },
          });
        setLoader(true);
        let accountRef = customerDetails.peerAccountRef.split('|');
        const numOfLine = (customerDetails && customerDetails.secondaryCustomers.length + 2).toString();
        const payload = {
            zipcode: customerDetails && customerDetails.zipcode ? customerDetails.zipcode : '01824',
            parentId: customerDetails && customerDetails.id,
            isMNP: false,
            isPrimary: false,
            primaryNumber: customerDetails && customerDetails.primaryNumber,
            addresses: address && address,
            status: 0,
            reachPlanId: customerDetails && customerDetails.reachPlanId,
            isSimInHand: false,
            extraLines: 0,
            selectedShippingMethod: customerDetails && customerDetails.selectedShippingMethod,
            esim: deviceDetails?.esim,
            imei: deviceDetails?.imei,
            make: deviceDetails?.make,
            model: deviceDetails?.model,
            activationJourneyStatus: 'NOT_STARTED',
            simPaid: true,
            peerAccountRef: `${accountRef[0]}|${accountRef[1]}|${numOfLine}`,
        };
        dispatch(
            CreateCustomer({
                countryCode: 'USA',
                data: payload,
            }),
        );
    };

    const executeShipmentOrder = (secCustomer: any) => {
        const { firstName, lastName, address1, city, state, zip, address2 } = formData;
        let totalAmount = shippingRates?.shippingAmount + simCost;
        let estimatedDeliveryDate: any = new Date();
        estimatedDeliveryDate.setDate(estimatedDeliveryDate.getDate() + shippingRates?.deliveryDays);
        estimatedDeliveryDate = estimatedDeliveryDate.getTime();

        const payload: any = {
            cId: customerDetails.id,
            reachCarrierId: shippingRates?.reachCarrierId,
            deliveryDays: shippingRates?.deliveryDays,
            serviceType: shippingRates?.serviceType,
            serviceCode: shippingRates?.serviceCode,
            carrierCode: shippingRates?.carrierCode,
            shipmentType: 'PHYSICAL',
            category: 'SIM',
            orderType: 'NEW',
            shippingAmount: shippingRates?.shippingAmount,
            estimatedDeliveryDate: estimatedDeliveryDate,
            taxAmount: 0,
            totalAmount: totalAmount,
            secondaryCustomers: secCustomer ? [secCustomer?.id] : [],
            shipTo: {
                city: city ? city : customerDetails?.addresses[0]?.city,
                country: 'US',
                name: firstName ? `${firstName} ${lastName}` : customerDetails?.addresses[0]?.name,
                phone: customerDetails?.addresses[0]?.phone,
                postalCode: zip ? zip : customerDetails?.addresses[0]?.zip,
                residential: 'false',
                state: state ? state : customerDetails?.addresses[0]?.state,
                street1: address1 ? address1 : customerDetails?.addresses[0]?.address1,
                street2: address2 ? address2 : customerDetails?.addresses[0]?.address2,
            },
            items: [
                {
                    quantity: 1,
                    unitPrice: simCost,
                },
            ],
        };
        isStandardAcc && 
            dispatch(
                ShippmentOrder({
                    data: payload,
                }),
            );
    };

    return (
        <>
            {!changeShipAddress ? (
                <div className="shippingAddLineDivContainer">
                    <div className="planDetailsContainer">
                        <div className="planDetails">
                            <div className="plan">
                                <div className="addLinePlanName">Welcome Kit w/SIM card</div>
                                <div className="addLinePlanPrice">${simCost ? simCost.toFixed(2) : '0.00'}</div>
                            </div>
                            <div className="shipping">
                                <div className="addLineShippingName">Standard shipping (3-6 days)</div>
                                <div className="addLineShippingPrice">
                                    ${shippingRates?.shippingAmount ? shippingRates?.shippingAmount.toFixed(2) : '0.00'}
                                </div>
                            </div>
                            <div className="line"></div>
                            <div className="note">
                                A one-time charge for this purchase will reflect in <br />
                                your upcoming invoice.
                            </div>
                            <div
                                className="terms"
                                onClick={() => {
                                    window.open(process.env.REACT_APP_ASTOUND_TERMS_AND_CONDITIONS_URL);
                                }}
                            >
                                Terms & Conditions
                            </div>
                        </div>
                    </div>
                    <div className="shippingAdd">
                        <Checkbox
                            color="default"
                            checked={isBillingAddress}
                            onChange={() => {
                                setIsBillingAddress(!isBillingAddress);
                            }}
                        />{''}
                        I want to ship my Welcome Kit to the address below:
                        <br />
                        {!shippingAddress?.address1 ? (
                            <span>
                                {billingAddress?.address1}
                                {', '}
                                {billingAddress?.address2 && billingAddress?.address2 + ', '}
                                {billingAddress?.city}
                                {', '}
                                {billingAddress?.state}
                            </span>
                        ) : (
                            <span>
                                {shippingAddress?.address1}
                                {', '}
                                {shippingAddress?.address2 && shippingAddress?.address2 + ', '}
                                {shippingAddress?.city}
                                {', '}
                                {shippingAddress?.state + ", "}
                                {shippingAddress?.zip}
                            </span>
                        )}
                        <div
                            className={isBillingAddress ? 'disableCTA changeTxt' : 'changeTxt'}
                            onClick={() => {
                                setIsBillingAddress(false);
                                setChangeShipAddress(true);
                                setIsChangeAddress(true);
                            }}
                        >
                            Edit address
                        </div>
                    </div>
                    <Button
                        onClick={() => {
                            if (!loader && !userCreated) {
                                handleCreateCustomer();
                            }
                        }}
                        disabled={!isBillingAddress}
                        primary={true}
                    >
                        {loader ? (
                            <div className="loaderCheck text-center">
                                <CircularProgress />
                            </div>
                        ) : (
                            'CONFIRM'
                        )}
                    </Button>
                </div>
            ) : (
                <div className="AddLineShippingAddressBlock">
                    <div className="addressSubTitle">We'll deliver your Welcome Kit to this address</div>
                    <div className="TextFieldsMain">
                        <div className="ProfileCol">
                            <div className="textFieldHead">Street</div>
                            <AutoComplete
                                value={formData.address1}
                                onChange={(e: any) => onChangeHandler(e, 'address1')}
                                onSelect={(e: any) => {
                                    handleSelect(e, 'billing');
                                }}
                            />
                            <div className="errorMessage">
                                {formDataValidation && formData.address1 === '' ? 'Address cannot be empty' : ''}
                            </div>
                        </div>
                        <div className="ProfileCol">
                            <div className="textFieldHead">Apt, unit or floor (Optional)</div>
                            <TextField
                                value={formData.address2}
                                onBlur={() => addressUpdateFunction(formData)}
                                onChange={(e: any) => onChangeHandler(e, 'address2')}
                                maxlength={maxLength}
                            />
                        </div>
                    </div>
                    <div className="TextFieldsMain">
                        <div className="ProfileCol">
                            <div className="textFieldHead">City</div>
                            <TextField
                                value={formData.city}
                                onBlur={() => addressUpdateFunction(formData)}
                                onChange={(e: any) => onChangeHandler(e, 'city')}
                                maxlength={maxLength}
                                disabled
                            />
                            <div className="errorMessage">
                                {formDataValidation && 
                                    formData.city === '' 
                                    ? 'City cannot be empty'
                                    : formDataValidation && formData.city.length < 2 
                                    ? 'City is invalid'
                                    : ''}
                            </div>
                        </div>
                        <div className="ProfileCol">
                            <div className="textFieldHead">State</div>
                            <SelectDropDown
                                key={formData.state}
                                value={formData.state}
                                options={usaState}
                                onChange={(e: any) => {
                                    onChangeHandler(e, 'state');
                                }}
                                disabled
                            />
                            <div className="errorMessage">
                                {formDataValidation && formData.state === '' ? 'State cannot be empty' : ''}
                            </div>
                        </div>
                    </div>
                    <div className="TextFieldsMain">
                        <div className="ProfileCol">
                            <div className="textFieldHead">ZIP Code</div>
                            <TextField
                                value={formData.zip}
                                maxlength={10}
                                onChange={(e: any) => {
                                    if (/^[0-9]+$/.test(e.target.value) || e.target.value === '') {
                                        onChangeHandler(e, 'zip');
                                    }
                                }}
                                disabled
                            />
                            <div className="errorMessage">
                                {formDataValidation && formData.zip === ''
                                    ? 'Zip code cannot be empty'
                                    : formDataValidation && formData.zip !== '' && !/^\d+$/.test(formData.zip)
                                    ? 'Please enter only digits'
                                    : formDataValidation && formData.zip !== '' && formData.zip.length < 5
                                    ? 'ZIP code must have 5 to 10 digits.'
                                    : ''}
                            </div>
                        </div>
                        <div className="ProfileCol">
                            <div className="textFieldHead">Country</div>
                            <SelectDropDown disabled options={[]} placeholder="United States" onChange={() => null} />
                        </div>
                    </div>
                    <div className="shippingAddressSaveButton">
                        <Button primary={true} onClick={!loader ? saveHandler : ()=> {}}>
                            {loader ? (
                                <div className="loaderCheck text-center">
                                    <CircularProgress />
                                </div>
                            ) : (
                                'CONTINUE'
                            )}
                        </Button>
                    </div>
                </div>
            )}
        </>
    );
};

export default OneTimeCharge;
